import * as React from 'react'
import { Element } from 'react-scroll'

interface Props {
}

export default class CompanyComponent extends React.Component<Props> {
	constructor(props: Props) {
		super(props)
	}

	render() {
		const members = [
			{
				role: 'CEO Founder / UIUX Designer',
				name: 'SEINOSUKE SAKAI',
				imageSrc: 'img/ic_member_sakai.jpg',
				description: `
				大学在学中にUIUXデザインの世界に魅了され、2012年よりフリーランスの「UIUXデザイナー」として、多くのプロジェクトに参画。
				主にスマートフォンアプリやWebアプリなどのUIUXデザインを数多く経験し、2016年11月に株式会社Candleに入社。
				UIUXだけではなく、チームビルディングやアートディレクション、グロースハック、情報設計、数値分析、採用、教育など、横断的に携わる。
				その後、2017年9月に前職を退き、株式会社GENESISを創業。UIUXデザインやグロースハックなど様々な角度で多くのクライアント企業とコラボレーションしている。
				`
			},
			{
				role: 'CTO Founder / Engineer',
				name: 'DAIKI INOUE',
				imageSrc: 'img/ic_member_inoue.jpg',
				description: `
				酒井と同じく、大学在学中にプログラミングの世界に魅了され、2012年よりフリーランスの「エンジニア」として、多くのプロジェクトに参画。
				主にスマートフォンアプリ開発を数多く経験し、その傍らプログラミングスクールの非常勤講師も経験後、2016年4月に株式会社エスキュービズムに新卒入社。
				そこで、Webアプリケーションの設計、開発、運用を経験後、R&Dで新規サービスの開発をリードエンジニアとして携わる。
				その後、2017年9月に前職を退き、酒井が創業した株式会社GENESISに共同創業者としてJoin。
				Web系の「PHP、Ruby、Node、Go」などに加え、アプリ系の「Swift、Java、Kotlin」から「MySQL、NoSQL」のデータベース、またAWSやAzureなどでのインフラ構築までできるフルスタックエンジニア。
				`
			}
		]
		const tableData = [
			{
				title: '会社名',
				value: '株式会社GENESIS（英文：GENESIS Co., Ltd.）'
			},
			{
				title: '所在地',
				value: '東京都港区北青山2-7-13　ブラセオ青山ビル3F'
			},
			{
				title: '設立',
				value: '2018年4月'
			},
			{
				title: '代表者',
				value: '酒井 聖之佑',
				isLast: true
			}
		]
		return (
			<Element name="company" className="section" id="company">
				<div className="row">
					<div className="container">
						<div className="col-xs-12 col-sm-12 section-title-en">
							<span>COMPANY</span>
						</div>
						<div className="col-xs-12 col-sm-12 section-title-ja">
							<span>最適なユーザー体験・ビジネスとしてのゴールを実現するためのサポートをします。</span>
						</div>
						{members.map((data, i) => {
							return (
								<div className="col-xs-12 col-sm-12" key={i}>
									<div className="col-xs-12 col-sm-3 member">
										<img src={data.imageSrc}/>
									</div>

									<div className="col-xs-12 col-sm-9 member">
										<div className="col-xs-12 role">{data.role}</div>
										<div className="col-xs-12 member-name">{data.name}</div>
										<div className="col-xs-12 member-description">
											<span>
												{data.description}
											</span>
										</div>
									</div>
								</div>
							)
						})}

						<div className="col-xs-12 col-sm-4 company-info">
							<div id="map-field">
								<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d684.297300228344!2d139.71800273541692!3d35.671015175475034!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188c9c0b3d36f1%3A0xa536077878e124b1!2z44Ob44OG44OrIOOCouODqeODnuODs-ODgOmdkuWxsQ!5e0!3m2!1sja!2sjp!4v1538883926483" width="600" height="450" style={{border: 0}} />
							</div>
						</div>

						<div className="col-xs-12 col-sm-8 company-info">
							{tableData.map((data, i) => {
								return (
									<div key={i} className="col-xs-12 col-sm-12 info-row" id={data.isLast ? 'last' : ''}>
										<div className="col-xs-12 col-sm-3 title">{data.title}</div>
										<div className="col-xs-12 col-sm-9 value">{data.value}</div>
									</div>
								)
							})}
						</div>
					</div>
				</div>
			</Element>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/welcome/components/companyComponent.tsx